import { Skeleton } from "@facade/components/ui";

export const ProjectsHomePageSkeleton = () => {
  return (
    <div className="flex justify-between items-end w-6xl">
      <div className="grid gap-4">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-4 w-32" />
      </div>
      <Skeleton className="h-8 w-32" />
    </div>
  );
};
